import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MobileNavSearch } from "../../components/Header/Header";
import { IsNullOrEmpty } from "../../helpers/utility";
import {
    addCartRequest,
    getCartRequest,
    getProductRequest,
    getProductsRequest,
} from "../../store/shopping/shopping.actions";
import { getProductsList } from "../../store/shopping/shopping.selector";
import {
    fetchLiveStreamByIdRequest,
    getFollowingStreamRequest,
    getRecentStreamRequest,
} from "../../store/social/social.actions";
import SocialAPI from "../../store/social/social.api";
import { getRecentLiveStreams } from "../../store/social/social.selector";
import {
    fetchOtherUserProfileRequest,
    followUserRequest,
    searchUserRequest,
    unfollowUserRequest,
} from "../../store/user/user.actions";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";

const SearchResult = () => {
    const history = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState("");

    const { allProducts, allUsers, recentLiveStreams, userProfile, cart } =
        useSelector((state) => {
            return {
                recentLiveStreams: getRecentLiveStreams(state),
                allUsers: getSearchedUsers(state),
                allProducts: getProductsList(state),
                userProfile: getUserProfile(state),
                cart: state.ShoppingReducer.cart
            };
        });

    useEffect(() => {
        if (location && location.state && location.state.searchText) {
            setSearchText(location.state.searchText);
        } else {
            setSearchText("");
        }
    }, [location]);

    useEffect(() => {
        dispatch(searchUserRequest());
        dispatch(getProductsRequest());
        dispatch(getProductRequest());
        dispatch(getFollowingStreamRequest());
        dispatch(getRecentStreamRequest());
        dispatch(getCartRequest())
    }, [searchText]);

    const searchData = {
        profiles: allUsers
            .filter((y) => y._id !== userProfile._id)
            .map((x) => {
                return {
                    id: x._id,
                    name: x.fullName,
                    userName: x.account.userName,
                    img: getImage(x.attachments),
                    country: x.country.isoCode,
                    isFollow: x.isFollow,
                };
            }),
        products: allProducts.map((x) => {
            return {
                id: x._id,
                name: x.name,
                userName: x.code,
                img: getImage(x.attachments, "product"),
                price: x.currency + " " + x.price,
                owner: x.user,
            };
        }),
        liveStreams: recentLiveStreams.map((x) => {
            return {
                id: x._id,
                name: x.title,
                userName: x.streamingStatus,
                img: getImage(x.attachments, true),
                viewing: x.totalWatch,
                owner: x.owner,
                video: x.s3Url,
            };
        }),
    };

    const { profiles, products, liveStreams } = searchData;

    let searchedProfiles = profiles;
    let searchedProducts = products;
    let searchedStreams = liveStreams;
    if (!IsNullOrEmpty(searchText)) {
        searchedProfiles = profiles.filter((stream) => {
            return (
                stream.name.toLowerCase().indexOf(searchText.toLowerCase()) >
                    -1 ||
                stream.userName
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    if (!IsNullOrEmpty(searchText)) {
        searchedProducts = products.filter((stream) => {
            return (
                stream.name.toLowerCase().indexOf(searchText.toLowerCase()) >
                    -1 ||
                stream.userName
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    if (!IsNullOrEmpty(searchText)) {
        searchedStreams = liveStreams.filter((stream) => {
            return (
                stream.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    if (
        searchedProfiles.length === 0 &&
        searchedProducts.length === 0 &&
        searchedStreams.length === 0
    ) {
        return (
            <div className="px-2 sm:px-4 lg:px-8 py-7">
                <div className="flex items-center justify-center w-full h-screen">
                    <div className="px-2 sm:px-4 lg:py-12">
                        <div className="flex flex-col items-center justify-center md:py-24 lg:py-32">
                            <p className="mb-2 text-xl sm:text-2xl font-bold text-center text-gray-800 md:text-3xl">
                                <span className="text-red-500">Oops!</span> No
                                result found :(
                            </p>
                            <p className="mb-8 text-center text-gray-500 md:text-lg">
                                We're sorry we couldn't find what you were
                                looking for. Please try another search
                            </p>
                            <Link
                                to="/"
                                className="px-6 py-2 text-sm font-semibold text-white bg-orange-color rounded-sm capitalize"
                            >
                                Go home
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="px-4 lg:px-8 py-7">
            <div className="md:hidden mb-2.5">
                <MobileNavSearch />
            </div>
            {searchedProfiles.length > 0 && (
                <div className="mb-5">
                    <div className="mb-2">
                        <h3 className="text-base font-bold text-ebony-color">
                            Profiles
                        </h3>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
                        {searchedProfiles.map((profile) => {
                            return (
                                <div
                                    key={profile.id}
                                    className="py-4 px-3 rounded-[10px] search-card-shadow bg-white min-w-[192px]"
                                >
                                    <div className="flex items-center gap-x-4 mb-5">
                                        <img
                                            src={profile.img}
                                            className="w-[63px] aspect-square rounded-full"
                                            alt=""
                                        />
                                        <div className="">
                                            <h4 className="text-sm font-bold text-ebony-color capitalize">
                                                {profile.name}
                                            </h4>
                                            <p className="text-sm font-normal text-ebony-color/70">
                                                @{profile.userName}
                                            </p>
                                            <p className="text-sm font-normal text-orange-color/70">
                                                ({profile.country})
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-x-[7px]">
                                        <button
                                            onClick={() =>
                                                dispatch(
                                                    fetchOtherUserProfileRequest(
                                                        profile.id,
                                                        history
                                                    )
                                                )
                                            }
                                            className="py-[7px] bg-white rounded-lg border border-black-10 w-full text-sm font-medium text-black-50 capitalize"
                                        >
                                            View Profile
                                        </button>
                                        <button
                                            onClick={() => {
                                                if (profile.isFollow) {
                                                    dispatch(
                                                        unfollowUserRequest({
                                                            following:
                                                                profile.id,
                                                        })
                                                    );
                                                } else {
                                                    dispatch(
                                                        followUserRequest({
                                                            following:
                                                                profile.id,
                                                        })
                                                    );
                                                }
                                            }}
                                            className={`py-[7px] ${
                                                profile.isFollow
                                                    ? "text-black-50"
                                                    : "bg-orange-color text-white"
                                            } rounded-lg border border-black-10 w-full text-sm font-bold  capitalize`}
                                        >
                                            {profile.isFollow
                                                ? "following"
                                                : "follow"}
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
            {searchedProducts.length > 0 && (
                <div className="mb-5">
                    <div className="mb-2">
                        <h3 className="text-base font-bold text-ebony-color capitalize">
                            products
                        </h3>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
                        {searchedProducts.map((product) => {
                            return (
                                <div
                                    key={product.id}
                                    className="py-4 px-3 rounded-[10px] search-card-shadow bg-white min-w-[192px]"
                                >
                                    <div className="flex items-center gap-x-4 mb-5">
                                        <img
                                            src={product.img}
                                            className="w-[63px] aspect-square "
                                            alt=""
                                        />
                                        <div className="">
                                            <h4 className="text-sm font-bold text-ebony-color capitalize">
                                                {product.name}
                                            </h4>
                                            <p className="text-sm font-normal text-ebony-color/70">
                                                {product.userName}
                                            </p>
                                            <p className="text-sm font-normal text-orange-color/70">
                                                {product.price}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-x-[7px]">
                                        <button
                                            onClick={() => {
                                                SocialAPI.GetDummyLivestream(
                                                    product.user
                                                ).then((x) => {
                                                    dispatch(
                                                        addCartRequest({
                                                            product: product.id,
                                                            quantity: 1,
                                                            livestream:
                                                                x.data._id,
                                                        })
                                                    );
                                                });
                                            }}
                                            className="py-[7px] bg-white rounded-lg border border-black-10 w-full text-sm font-medium text-black-50 capitalize"
                                        >
                                            Add to Cart
                                        </button>
                                        <button
                                            onClick={() => {
                                                SocialAPI.GetDummyLivestream(
                                                    product.user
                                                ).then((x) => {
                                                    dispatch(
                                                        addCartRequest({
                                                            product: product.id,
                                                            quantity: 1,
                                                            livestream:
                                                                x.data._id,
                                                            history: history,
                                                            canNavigate: true,
                                                        })
                                                    );
                                                });
                                            }}
                                            className="py-[7px] bg-orange-color rounded-lg border border-black-10 w-full text-sm font-bold text-white capitalize"
                                        >
                                            Buy Now
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {searchedStreams.length > 0 && (
                <div className="mb-5">
                    <div className="mb-2">
                        <h3 className="text-base font-bold text-ebony-color capitalize">
                            Videos
                        </h3>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
                        {searchedStreams.map((stream) => {
                            return (
                                <div
                                    key={stream.id}
                                    className="py-4 px-3 rounded-[10px] search-card-shadow bg-white min-w-[192px]"
                                >
                                    <div className="flex items-center gap-x-4 mb-5">
                                        {stream.video ? (
                                            <video
                                                src={stream?.video}
                                                muted
                                                playsInline
                                                height={48}
                                                width={48}
                                            />
                                        ) : (
                                            <img
                                                src={stream.img}
                                                className="w-[63px] aspect-square rounded-md"
                                                alt=""
                                            />
                                        )}

                                        <div className="">
                                            <h4 className="text-sm font-bold text-ebony-color capitalize">
                                                {stream.name}
                                            </h4>
                                            <p className="text-sm font-normal text-ebony-color/70">
                                                {stream.userName}
                                            </p>
                                            <p className="text-sm font-normal text-orange-color/70">
                                                {stream.viewing}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-x-[7px]">
                                        <button
                                            onClick={() =>
                                                dispatch(
                                                    fetchOtherUserProfileRequest(
                                                        stream.owner._id,
                                                        history
                                                    )
                                                )
                                            }
                                            className="py-[7px] bg-white rounded-lg border border-black-10 w-full text-sm font-medium text-black-50 capitalize"
                                        >
                                            View Profile
                                        </button>
                                        <button
                                            onClick={() =>
                                                dispatch(
                                                    fetchLiveStreamByIdRequest({
                                                        id: stream.id,
                                                        history: history,
                                                    })
                                                )
                                            }
                                            className="py-[7px] bg-orange-color rounded-lg border border-black-10 w-full text-sm font-bold text-white capitalize"
                                        >
                                            {stream.userName === "Ended"
                                                ? "View Live"
                                                : "Join Now"}
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchResult;
